import { API } from './resources'

export default {
  link: (projectID, url, key) => {
    return API.post('/upload/link', { projectID, url, key })
  },
  header: (url) => {
    return API.get('/upload/header', { params: { url } })
  },
  image: (projectID, url, key) => {
    return API.post('/upload/image', { projectID, url, key })
  },
  file: (projectID, url, key) => {
    return API.post('/upload/file', { projectID, url, key })
  },
  linkV3: (url) => {
    return API.post('/upload/link/v3', { url })
  },
  iframeV3: (url) => {
    return API.post('/upload/iframe/v3', { url })
  },
  imageV3: (url, key) => {
    return API.post('/upload/image/v3', { url, key })
  },
  fileV3: (url, key) => {
    return API.post('/upload/file/v3', { url, key })
  },
  whiteboardV3: (url, key) => {
    return API.post('/upload/whiteboard/v3', { url, key })
  },
  video: async (videoUrl, traceId, width, height) => {
    return API.post('/upload/video', { traceId, width, height, videoUrl })
  }
}
